export default "__VITE_ASSET__s7F8T8qR__"